import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment/moment';
//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import TextField from '../../components/TextField/TextField';
import Loading from '../../components/Loading/Loading';
//Api
import naoColeta_api from '../../api/naoColeta_api';
import gerador_api from '../../api/gerador_api';
//Helpers
import { showMessage } from '../../helpers/message';
import { validarCampos, objCampo, PrintValidate } from '../../helpers/ValidadorDeCampos';
import FichaPesquisaNaoColeta from './FichaPesquisaNaoColeta';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

function initialStateFiltros() {
    const dataFim = new Date();
    const dataInicio = new Date();
    dataInicio.setMonth(dataFim.getMonth() - 1);

    return {
        dataInicial: moment(dataInicio).format("YYYY-MM-DD"),
        dataFinal: moment(dataFim).format("YYYY-MM-DD"),
        geradorId: 0,
        geradorId_Selected: null
    }
}
export default function PesquisaNaoColeta() {
    //Estado de controle da ficha da não coleta
    const [ficha, setFicha] = useState(null);

    //Estado que guarda os campos com erros
    const [errors, setErrors] = useState({});

    //Campos obrigatorios dos filtros
    const camposFiltros = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
    ]

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle do formulario de filtros
    const [openFiltros, setOpenFiltros] = useState(false);

    //Estado de controle dos dados dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Estado que guarda a lista de geradores
    const [geradores, setGeradores] = useState([]);

    //Muda o estado do formulario de filtros
    const toggleFiltros = () => setOpenFiltros(!openFiltros);

    //Estado que guarda a lista de não coletas
    const [naoColetas, setNaoColetas] = useState([]);

    //Função que carrega todas as não coletas
    const loadNaoColetas = () => {
        const _errors = validarCampos(filtros, camposFiltros);
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        } else if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            const newErrors = { dataInicial: { message: "Data inicial maior do que data final" } }
            setErrors(newErrors);
            return;
        } else {
            setErrors({});
        }
        setLoading(true);
        const _filtros = { ...filtros }
        _filtros.dataInicial = _filtros.dataInicial + " 00:00:00";
        _filtros.dataFinal = _filtros.dataFinal + " 23:59:59";
        naoColeta_api.GetList(_filtros).then(response => {
            response.data = response.data.map(value => {
                value.dataHora = moment(value.dataHora).format("DD/MM/YYYY HH:mm:ss");
                return value;
            });
            setNaoColetas(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }
    //Carrega os do select de geradores
    const loadGeradores = () => {
        setLoading(true);
        gerador_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.fantasia }
            })
            setGeradores(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Carrega os dados da não coleta
    useEffect(() => {
        loadNaoColetas();
        loadGeradores();
    }, []);

    //Cabeçalhos da tabela
    const headers = [
        { value: "Numero da não coleta", objectValue: "id", align: "left" },
        { value: "Data", objectValue: "dataHora", align: "left" },
        { value: "Motivo", objectValue: "motivo", align: "left" },
        { value: "Coletor", objectValue: "coletor", align: "left" },
        { value: "Gerador", objectValue: "gerador", align: "left" },
        { value: "Localidade", objectValue: "localidade", align: "left" },
    ]

    //Change dos campos de data
    const onChangeDateInput = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Change para o select de gerador
    const onChangeGerador = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        })
    }
    //Ações da tabela de listagem
    const actions = [actionsTable.visualizar(rowData => setFicha(rowData))];
    if (ficha) {
        return (<FichaPesquisaNaoColeta btnVoltar={() => setFicha(null)} naoColeta={ficha} />);
    }

    return (
        <MainCard noCard btnFiltros={toggleFiltros}>
            {loading && <Loading />}
            <div className={`filtros ${openFiltros ? "" : "close"} mb-4`}>

                <Row>
                    <Col lg={"4"} md="6" sm="12">
                        <TextField label="Início *" type={"date"} name={"dataInicial"} onChange={onChangeDateInput} value={filtros.dataInicial} invalid={errors.dataInicial ? true : false} />
                        <PrintValidate errors={errors} field={"dataInicial"} />
                    </Col>
                    <Col lg={"4"} md="6" sm="12">
                        <TextField label="Fim *" type={"date"} name={"dataFinal"} onChange={onChangeDateInput} value={filtros.dataFinal} invalid={errors.dataFinal ? true : false} />
                        <PrintValidate errors={errors} field={"dataFinal"} />
                    </Col>
                    <Col lg={"4"} md="6" sm="12">
                        <TextField label="Geradores" type={"select"} searchable name={"geradorId_Selected"} onChange={onChangeGerador} value={filtros.geradorId_Selected} options={geradores} />
                    </Col>
                </Row>
                <div className='mt-3 ms-3'>
                    <Button className='fw-bold' color='info' style={{ color: "#fff" }} onClick={() => loadNaoColetas()}>
                        <FontAwesomeIcon className='me-2' icon={faSearch} /> Pesquisar
                    </Button>
                </div>
            </div>
            <TabelaListagem actions={actions} options={{ print: false, search: true, pagination: true }} title='Lista de não coletas' headers={headers} items={naoColetas} />
        </MainCard>
    );
}